import React from 'react'
import { Column } from 'react-virtualized'

import Table from '../../../containers/Tables/components/Table'
import TableStyles from '../../../containers/Tables/components/Table/Table.css'
import TableHeader from '../../../containers/Tables/components/TableHeader'
import TableActions from '../../../containers/Tables/components/TableActions'
import TableActionStyles from '../../../containers/Tables/components/TableActions/TableActions.css'
import { SearchPopover } from '../../../containers/Popovers'
import styles from './TeamInvitesTable.css'
import CancelIcon from 'static/images/cancel.svg'
import { TEAM_INVITES_TABLE_COLUMN_HEADERS, TABLE_CHECKBOX_WIDTH, TABLE_BULK_ACTIONS } from '../../../constants'
import Loading from '../../../components/Loading'
import { getSelectedList } from '../../../containers/Tables/Utilities'

class TeamInvitesTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: {},
    }
  }

  static getDerivedStateFromProps(props, s) {
    const state = s

    if (state.selected !== props.selected) {
      state.selected = props.selected
    }

    return state
  }

  handleOnSelectionClick = selected => {
    const {
      onSelectionClick,
    } = this.props

    this.setState({
      selected,
    })

    if (onSelectionClick) {
      onSelectionClick(selected)
    }
  }

  render() {
    const {
      noDataText = 'There are no pending invites.',
      enableLoader,
      showLoader,
      showRowSelection = false,
      data,
      width,
      onRowClick,
      sortBy,
      sortDirection,
      rowHeight = 50,

      filterEmail,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnSortClick,
      handleOnOutsidePopoverClick,
      handleOnBulkAction,
      handleOnBulkActionClearSelection,
      handleOnPopoverKeyUp,
      bulkActionComplete,
      bulkActionIsFetching,
      selectedPopover,

      selectedEmail,
    } = this.props
    const {
      selected,
    } = this.state

    const isAnySelected = Object.keys(selected).some(key => selected[key] === true)

    let emailWidth = width
    let emailPopoverClassname = styles.emailPopover

    if (showRowSelection) {
      emailWidth -= TABLE_CHECKBOX_WIDTH
      emailPopoverClassname = styles.emailPopoverWithSelection
    }

    const numberOfSelection = getSelectedList(selected).length

    return (
      <div className={styles.teamInvitesTable}>
        <Table
          noDataText={noDataText}
          enableLoader={enableLoader}
          showLoader={showLoader}
          // headerHeight={35}
          showRowSelection={showRowSelection}
          disableRowSelection={bulkActionComplete || bulkActionIsFetching}
          selected={selected}
          rowHeight={rowHeight}
          uniqueKey="id"
          hasTableActions={isAnySelected}
          onSelectionClick={this.handleOnSelectionClick}
          onRowClick={onRowClick}
          data={data}
          sortBy={sortBy}
          sortDirection={sortDirection}
        >
          <Column
            className={TableStyles.column}
            label="Email"
            dataKey={TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL}
            width={emailWidth}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterEmail}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={emailPopoverClassname}>
                      <SearchPopover
                        handleOnPopoverKeyUp={handleOnPopoverKeyUp}
                        handleOnChange={email => handleOnFilterChange(TEAM_INVITES_TABLE_COLUMN_HEADERS.EMAIL, email)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        value={selectedEmail}
                        placeholder="Email..."
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => (
              <div className={TableStyles.centeredColumnContent}>
                <p className={TableStyles.primaryText}>
                  {rowData[dataKey]}
                </p>
              </div>
            )}
          />
        </Table>
        <TableActions
          selected={selected}
          visible={isAnySelected}
          clearSelection={handleOnBulkActionClearSelection}
          bulkActionComplete={bulkActionComplete}
          bulkActionIsFetching={bulkActionIsFetching}
          // eventually when there is more than 1 option, this will need to become a system to support which bulk
          // action was taken and show the cooresponding success or failure message
          successMessage={numberOfSelection === 1
            ? `${numberOfSelection} invitation has been revoked.`
            : `${numberOfSelection} invitations have been revoked.`
          }
        >
          {bulkActionIsFetching
            ? (
              <button disabled className={TableActionStyles.submitLoading}>
                <Loading />
              </button>
            )
            : (
              <button
                className={TableActionStyles.actionButton}
                onClick={() => handleOnBulkAction(TABLE_BULK_ACTIONS.REVOKE_FROM_TEAM)}
              >
                <CancelIcon className={styles.cancelIcon} />
                <span>Revoke</span>
              </button>
            )
          }
        </TableActions>
      </div>
    )
  }
}

export default TeamInvitesTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/TeamInvitesTable/TeamInvitesTable.jsx